import Vue from 'vue';
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner.vue';

Vue.component('EpicSpinner', HalfCircleSpinner);
